import React from 'react';

interface CheckSuccessIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const CheckSuccessIcon: React.FC<CheckSuccessIconProps> = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.2167 5.60506L7.82778 15.9908C7.63889 16.1796 7.45 16.274 7.16667 16.274C6.88333 16.274 6.69444 16.1796 6.50556 15.9908L1.78333 11.27C1.40556 10.8923 1.40556 10.3258 1.78333 9.94817C2.16111 9.57051 2.72778 9.57051 3.10556 9.94817L7.16667 14.008L16.8944 4.28325C17.2722 3.90558 17.8389 3.90558 18.2167 4.28325C18.5944 4.66091 18.5944 5.2274 18.2167 5.60506Z"
        fill="#009846"
      />
    </svg>
  );
};
